import { useHomeBanner, useServiceAILearningChatbot } from '@/src/api/getData';
import Banner from '@/components/banner';
import Card from '@/components/card';
import DynamicContent from '@/components/dynamicContent';

const ITechChatbotView: any = ({ language = '' }) => {
    const { data: banner } = useHomeBanner(language);
    const { data: aiLearningChatbot } = useServiceAILearningChatbot(language);
    let aiLearningChatbotData = aiLearningChatbot?.data || {};

    return (
        <main className='bg-2' id="start">
            <Banner banner={banner} category="AI Learning Chatbot" />
            <Card cardData={aiLearningChatbotData?.Card_video?.Cards || []} cardType="orange-card" />
            <DynamicContent content={aiLearningChatbotData?.Content} />
        </main>
    );
}

export default ITechChatbotView;